import { Box, Container, Grid, Typography } from '@mui/material';
import { FC } from 'react';
import marketTrend from '../../assets/images/marketTrend.png';
import browse from '../../assets/images/browse.png';
import invest from '../../assets/images/invest.png';
import earn from '../../assets/images/earn.png';
import { useInView } from '../../hooks/useInView';

const PRIMARY = '#8c7c0c';

const STEPS = [
    { image: browse, step: '01', title: 'Browse Properties', desc: 'Select a property that fits your goal from our curated selection of high-potential listings.' },
    { image: invest, step: '02', title: 'View & Invest', desc: 'Access rental yield data, market trends, and analytics before committing.' },
    { image: earn, step: '03', title: 'Earn & Track', desc: 'Monitor portfolio performance and total returns in real time — all in one dashboard.' },
];

const Investor: FC = () => {
    const { ref, visible } = useInView();

    return (
        <Box component="section" id="investor" ref={ref} sx={{ py: { xs: 8, md: 12 }, bgcolor: '#f9f8f4' }}>
            <Container maxWidth="lg">
                <Grid container spacing={{ xs: 6, md: 8 }} alignItems="center">
                    {/* Image */}
                    <Grid item xs={12} md={5}>
                        <Box className={`sg-reveal-left ${visible ? 'sg-visible' : ''}`}>
                            <img
                                src={marketTrend}
                                alt="Investment dashboard"
                                loading="lazy"
                                style={{ width: '100%', objectFit: 'contain', borderRadius: 16, filter: 'drop-shadow(0 12px 32px rgba(0,0,0,.1))' }}
                            />
                        </Box>
                    </Grid>

                    {/* Copy */}
                    <Grid item xs={12} md={7}>
                        <Box className={`sg-reveal-right ${visible ? 'sg-visible' : ''}`}>
                            <Typography sx={{ display: 'inline-block', bgcolor: `${PRIMARY}12`, color: PRIMARY, px: 2, py: 0.5, borderRadius: 20, fontSize: 13, fontWeight: 600, mb: 2 }}>
                                For Investors
                            </Typography>
                            <Typography component="h2" sx={{ fontSize: { xs: 30, md: 42 }, fontWeight: 800, color: '#111827', lineHeight: 1.2, mb: 2 }}>
                                Real Estate Investment Made Accessible
                            </Typography>
                            <Typography sx={{ fontSize: 16, color: '#6b7280', lineHeight: 1.7, mb: 5 }}>
                                Whether you're abroad or local, Sheltergram connects you with trusted developers and high-potential properties. Track progress remotely and make secure payments — transparent, reliable, and built to your vision.
                            </Typography>

                            <Grid container spacing={3}>
                                {STEPS.map(({ image, step, title, desc }, i) => (
                                    <Grid item xs={12} sm={4} key={step}>
                                        <Box
                                            className={`sg-reveal sg-card-lift ${visible ? 'sg-visible' : ''}`}
                                            style={{ transitionDelay: `${i * 0.1 + 0.2}s` }}
                                            sx={{ textAlign: 'center', p: 2.5, borderRadius: 3, bgcolor: '#fff', border: '1px solid #e5e7eb' }}
                                        >
                                            <img src={image} alt={title} loading="lazy" style={{ width: 80, height: 80, objectFit: 'contain', marginBottom: 12 }} />
                                            <Box sx={{ display: 'inline-block', bgcolor: PRIMARY, color: '#fff', borderRadius: '50%', width: 28, height: 28, lineHeight: '28px', fontSize: 12, fontWeight: 700, mb: 1 }}>
                                                {step}
                                            </Box>
                                            <Typography sx={{ fontWeight: 700, fontSize: 15, color: '#111827', mb: 0.5 }}>{title}</Typography>
                                            <Typography sx={{ fontSize: 13, color: '#6b7280', lineHeight: 1.6 }}>{desc}</Typography>
                                        </Box>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Investor;
